import AgentActivity from 'models/agent_activity';
import setAgentLocalState from 'actions/agent_local_state/set_agent_local_state';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';
import { SidePanelType } from 'models/side_panel';

export default class CloseTeamAssistPanel {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, compositionId }) {
    const sidePanel = this.context.stores.sidePanel.get();
    if (sidePanel.isShowing(SidePanelType.AI_ASSIST)) {
      sidePanel.close();
      this.context.stores.sidePanel.set(sidePanel);

      const localState = this.context.stores.agentLocalState.get();
      localState.setSidePanel(sidePanel);
      setAgentLocalState(this.context, localState);

      // Server-side activity ping (parallel to the FullStory event below).
      // Mirrors the TASK_COMMENT_PANEL_CLOSE pattern.
      this.context.executeAction(SetAndLogActivity, {
        type: AgentActivity.Type.TEAM_ASSIST_PANEL_CLOSE,
      });

      this.context.analytics.track('Team Assist Panel Closed', { customerId, conversationId, compositionId });
    }
  }
}
